<template>
  <Select
    :items="arrayStatusPedido"
    :selectedItem="filter.statusPedido"
    :label="filtro.name"
    :searchPlaceholder="$i18n('interface.novo_filtro.buscar_status')"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :filtro_default="filtro.default"
    :path="path"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    },
    initialState: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      filter: {
        statusPedido: {
          id: '',
          name: '',
        },
      },
      arrayStatusPedido: [],
    };
  },
  methods: {
    atualizar(statusPedido) {
      this.filter.statusPedido = statusPedido;

      this.$aplicaFiltroEmURL(this.filtro.filtro, this.filter.statusPedido.id, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: this.filter.statusPedido.id
      });
    },
  },
  created() {
    this.arrayStatusPedido = this.filtro.parametros?.opcoes_status_pedido || [];
  },
  mounted() {
    const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
    this.$renderFiltroSelect(filtroAplicado, this.arrayStatusPedido, this.filter.statusPedido);
  },
}
</script>
